import { postMessage } from '../utils/postMessage';
import { getClosedWidgetSize } from './getClosedWidgetSize';

export const postIframeResizeEvent = () => {
  const closedWidgetSize = getClosedWidgetSize();

  postMessage({
    dimensions: {
      height: `${closedWidgetSize.height}px`,
      width: `${closedWidgetSize.width}px`,
    },
    event: 'forethoughtWidgetResize',
  });
};
